module.exports = __webpack_public_path__ + "static/img/google-logo.e06a153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/google-logo.png
// module id = qrDF
// module chunks = 1